<script setup>
import { computed } from 'vue';

import ContextHelp from './ContextHelp.vue';
import Icon from './Icon.vue';

defineOptions({ name: 'DsStat' });

const props = defineProps({
  label: { type: String, default: null },
  helpKey: { type: String, default: null },
  value: { type: [String, Number], default: null },
  unit: { type: String, default: null },
  delta: { type: String, default: null },
  deltaTone: { type: String, default: 'neutral' },
  deltaDirection: { type: String, default: 'flat' },
  hint: { type: String, default: null },
  // hero / medium / small — controla el tamaño del valor (sustituye a
  // MetricAnchorLegacy size).
  size: {
    type: String,
    default: 'medium',
    validator: (v) => ['hero', 'medium', 'small'].includes(v)
  }
});

const deltaIcon = computed(() =>
  props.deltaDirection === 'up' ? 'arrowUp' : props.deltaDirection === 'down' ? 'arrowDn' : 'arrowR'
);
</script>

<template>
  <div :class="['ds-stat', `ds-stat--${size}`]">
    <div class="ds-stat__label">
      {{ label }}
      <ContextHelp
        v-if="helpKey"
        :help-key="helpKey"
      />
    </div>
    <div class="ds-stat__value-row">
      <span
        class="ds-stat__value"
        aria-live="polite"
      >{{ value }}</span>
      <span
        v-if="unit"
        class="ds-stat__unit"
      >{{ unit }}</span>
      <span
        v-if="delta"
        :class="['ds-stat__delta', `ds-stat__delta--${deltaTone}`]"
      >
        <Icon
          :name="deltaIcon"
          :size="11"
          :stroke="2.5"
        />
        {{ delta }}
      </span>
    </div>
    <div
      v-if="hint"
      class="ds-stat__hint"
    >
      {{ hint }}
    </div>
  </div>
</template>

<style scoped>
.ds-stat--hero .ds-stat__value {
  font-size: var(--text-5xl);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-tight);
}

.ds-stat--medium .ds-stat__value {
  font-size: var(--text-4xl);
}

.ds-stat--small .ds-stat__value {
  font-size: var(--text-2xl);
}
</style>
